module.exports = __webpack_public_path__ + "static/media/mineduc.3dbcf1b5.png";